<div class="max-w-screen-sm mx-auto">
  @if (heading) {
    <h2
      class="font-brand text-neutral-900 text-2xl"
      [innerHTML]="heading"
    ></h2>
  }
  @if (text) {
    <div
      class="font-base text-neutral-600 text-sm"
      [innerHTML]="text"
    ></div>
  }
</div>
